/**
 * Set up routing for all Study views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import study views
import ContactUs from './views/ContactUs.js.jsx';
import LandingPageLogin from '../user/views/LandingPageLogin.js.jsx';

class StaticRouter extends Base {
  constructor(props) {
    super(props);
  }

 // NOT CURRENTLY USED - these are defined in routes.js.jsx
  render() {
    return (
      <Switch>
        {/* <YTRoute exact path="/partner/:name" component={LandingPageLogin} /> */}
        {/* <YTRoute exact path="/portal/:name" component={LandingPageLogin} /> */}
        <YTRoute login={true} exact path="/contact-us" component={ContactUs} />
      </Switch>
    )
  }
}

export default StaticRouter;



// WEBPACK FOOTER //
// modules/static/StaticRouter.js.jsx